export default "__VITE_ASSET__CHk5TJgq__"